// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root___uSf5","rightAdornment":"Header_rightAdornment__4-Ojd"};